export default {
  setFinance: (state, payload) => {
    state.finance = payload
  },
  setMonthly: (state, payload) => {
    if (!('finance' in state.finance)) {
      state.finance = {}
    }
    state.finance.summary = {
      details: payload.details,
      date: payload.date,
    }
  },
}
